import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { Condition } from '@/components/pages/Applicant/components/ApplicantConditions/ApplicantConditions.types';

import { getApplicantConditions } from '../endpoints/applicantConditions';
import { FOCUS_STALE_TIME_MS } from './staleTime';

interface UseConditionsQueryProps {
    applicantId: string;
    enabled?: boolean;
}

export const useConditionsQuery = ({
    applicantId,
    enabled = true,
}: UseConditionsQueryProps): UseQueryResult<Condition[], AxiosError> =>
    useQuery({
        queryKey: ['applicant-conditions', applicantId],
        staleTime: FOCUS_STALE_TIME_MS,
        enabled: Boolean(applicantId) && enabled,
        queryFn: () => getApplicantConditions(applicantId),
        refetchInterval: 30_000,
    });
